import AppCard from "@lib/components/AppComponents/AppCard";
import { Button, Tag, Typography } from "antd";
import styled from "styled-components";

export const StyledCustomMenu = styled(AppCard)`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  background: ${({ theme }) => theme.palette.background.paper};
  border: 2px solid ${({ theme }) => theme.palette.borderColor};
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
  width: 250px;

  .ant-card-body {
    padding: 0;
  }
`;

export const StyledCustomMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid ${({ theme }) => theme.palette.borderColor};
  padding-bottom: 10px;
  margin-bottom: 10px;
`;

export const StyledCustomMenuTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 600;
`;

export const StyledCustomMenuCloseButton = styled(Button)`
  width: 100%;
`;

export const StyledCustomMenuChild = styled.div`
  margin: 20px 0;
`;

export const StyledCustomMenuChildNodes = styled.div`
  border: 2px dashed ${({ theme }) => theme.palette.borderColor};
  padding: 10px;
  border-radius: 10px;
`;

export const StyledCustomMenuChildNode = styled(Tag)`
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.background.secondary} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }
`;

export const StyledCustomMenuFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
`;

export const StyledCustomMenuAddChildButton = styled(Button)``;
